import React from "react";
import iconDream1 from "../../../assets/images/create-dream-icons/icon-dream-1.svg";
import iconDream2 from "../../../assets/images/create-dream-icons/icon-dream-2.svg";
import iconDream3 from "../../../assets/images/create-dream-icons/icon-dream-3.svg";
import iconDream4 from "../../../assets/images/create-dream-icons/icon-dream-4.svg";
import iconDream5 from "../../../assets/images/create-dream-icons/icon-dream-5.svg";
import useIsMobile from "src/hooks/useIsMobile";

interface UploadDreamPhotosProps {
  setUploadedPhotos: React.Dispatch<React.SetStateAction<File[]>>;
  uploadedPhotos: File[];
  isDisabled?: boolean;
  addedImages?: any;
}

const UploadDreamPhotos = ({
  setUploadedPhotos,
  uploadedPhotos,
  isDisabled,
  addedImages,
}: UploadDreamPhotosProps) => {
  const isMobile = useIsMobile(750);
  const icons = [iconDream1, iconDream2, iconDream3, iconDream4, iconDream5];

  const handleProfileImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (uploadedPhotos.length < 5) {
      const images = Array.from(e.target.files || []);
      setUploadedPhotos((prev) => {
        const newPhotos = [...prev, ...images].slice(0, 5);
        return newPhotos;
      });
    }
  };

  const handleDeleteProfileImg = (index: number) => {
    setUploadedPhotos((prevPhotos) => prevPhotos.filter((_, i) => i !== index));
  };

  const displayPhotos = isDisabled
    ? [...addedImages, ...Array(5 - addedImages.length).fill(null)]
    : [...uploadedPhotos, ...Array(5 - uploadedPhotos.length).fill(null)];

  const isActiveBtn = isDisabled ? false : uploadedPhotos.length < 5;
  return (
    <div className="upload-photos-container">
      <div className="uploaded-pictures">
        {displayPhotos.map((photo, index) => (
          <div key={index} className="dream-pictures-white-bg">
            <div className="dream-square-pictures">
              <img
                key={index}
                src={
                  isDisabled
                    ? photo
                      ? photo
                      : icons[index]
                    : photo
                    ? URL.createObjectURL(photo)
                    : icons[index]
                }
                alt={`dream-icon-${index + 1}`}
                className="dream-image-uploaded"
              />
              {photo && !isDisabled && (
                <img
                  src="../../interact/delete-image.svg"
                  alt="Delete"
                  className={
                    isMobile
                      ? "profile-edit-delete-image"
                      : "profile-image-uploaded-deleted"
                  }
                  style={{ left: "2px" }}
                  onClick={() => handleDeleteProfileImg(index)}
                />
              )}
            </div>
          </div>
        ))}
      </div>
      {isActiveBtn ? (
        <div className="custom-gradient sliders-button tooltip-angel-button-text upload-btn">
          <input
            className="input-file-upload"
            type="file"
            accept="image/png, image/jpeg, image/jpg"
            name="image"
            id="image"
            multiple
            onChange={handleProfileImageChange}
          />
          Upload
        </div>
      ) : (
        <div className="disabled-btn upload-btn cursor-pointer">
          <span className="disabled-text">Upload</span>
        </div>
      )}
      <span className="upload-info"> *at least one picture</span>
    </div>
  );
};

export default UploadDreamPhotos;
